import utils from '@/util/utils' // 工具类
import $date from '@/plugin/date' // 工具类
import $number from '@/plugin/number' // 工具类
import $wx from '@/plugin/wxjssdk' // 工具类

import VueCropper from 'vue-cropper'
import VueScroller from 'vue-scroller' // vue scroller

import VueCompositionApi from '@vue/composition-api' // composition-api
import vant from 'vant'

export default [
  VueScroller,
  VueCompositionApi,
  utils,
  vant,
  $date,
  $number,
  VueCropper,
  $wx
]
